import MoreVertIcon from '@mui/icons-material/MoreVert'
import CardHeader from '@mui/material/CardHeader'
import IconButton from '@mui/material/IconButton'
import React from 'react'

import { getExceptionTypeLabel } from 'settings/constants/exceptionType'

import ExceptionTypeAvatar from './ExceptionTypeAvatar'

// Header row: type avatar + type label + kebab. The kebab's menu lives in the
// orchestrator (it drives the edit/delete dialogs); the header only opens it.
type ExceptionCardHeaderProps = {
  exceptionType?: string
  onMenuOpen: (event: React.MouseEvent<HTMLElement>) => void
}

const ExceptionCardHeader: React.FC<ExceptionCardHeaderProps> = ({ exceptionType, onMenuOpen }) => (
  <CardHeader
    action={
      <IconButton size="small" onClick={onMenuOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
    }
    avatar={<ExceptionTypeAvatar exceptionType={exceptionType} />}
    slotProps={{ title: { variant: 'h6', fontWeight: 'normal' } }}
    sx={{ py: 1, '& .MuiCardHeader-avatar': { mr: 1 }, '& .MuiCardHeader-action': { alignSelf: 'center', m: 0 } }}
    title={getExceptionTypeLabel(exceptionType)}
  />
)

export default ExceptionCardHeader
